import React, { useState, useEffect } from 'react';

export const StepOne = (props) => {

    const [data, setData] = useState({
        identification: props.data.identification,
        firstName: props.data.firstName,
        secondName: props.data.secondName,
        firstLastName: props.data.firstLastName,
        secondLastName: props.data.secondLastName,
        gender: props.data.gender,
        email: props.data.email,
        direction: props.data.direction,
        phone: props.data.phone,
    })

    const handleChange = (prop, value) => {
        if(prop === 'identification') {
            if(isNaN(value)) {
                return;
            }
        }
        setData((prevState) => ({
            ...prevState,
            [prop]: value, 
        }));
    }

    useEffect((props) => { 
        props.updateStepData('one', data)
    }, [data])



    return(
            <div style={{padding:50}}>
                <div className="px-4 sm:px-0">
                    <h3 className="text-base/7 font-semibold text-gray-900">Informacion del Infractor</h3>
                    <p className="mt-1 max-w-2xl text-sm/6 text-gray-500"></p>
                </div>
                <div className="mt-6 border-t border-gray-100">
                    <dl className="divide-y divide-gray-100">
                        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                                <div>
                                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                        Identificacion
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            value={data.identification}
                                            onChange={(e) => {handleChange('identification', e.target.value)}}
                                            id="email"
                                            name="email"
                                            type="text"
                                            placeholder=""
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                        />
                                    </div>
                                </div>
                            </dd>
                            
                        </div>
                        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                                <div>
                                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                        Nombres
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            value={data.firstName}
                                            onChange={(e) => {handleChange('firstName', e.target.value)}}
                                            id="email"
                                            name="email"
                                            type="text"
                                            placeholder=""
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                        />
                                    </div>
                                </div>
                            </dd>
                        </div>
                        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                                <div>
                                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                        Apellidos
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            value={data.firstLastName}
                                            onChange={(e) => {handleChange('firstLastName', e.target.value)}}
                                            id="email"
                                            name="email"
                                            type="text"
                                            placeholder=""
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                        />
                                    </div>
                                </div>
                            </dd>
                        </div>
                        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                                <div>
                                    <label htmlFor="location" className="block text-sm/6 font-medium text-gray-900">
                                        Genero
                                    </label>
                                    <select
                                        value={data.gender}
                                        onChange={(e) => {handleChange('gender', e.target.value)}}
                                        id="location"
                                        name="location"
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                    >
                                        <option value={null}>SELECCIONAR</option>
                                        <option value={'M'}>Masculino</option>
                                        <option value={'F'}>Femenino</option>
                                    </select>
                                </div>
                            </dd>
                        </div>
                        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                                <div>
                                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                        Correo
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            value={data.email}
                                            onChange={(e) => {handleChange('email', e.target.value)}}
                                            id="email"
                                            name="email"
                                            type="text"
                                            placeholder=""
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                            />
                                    </div>
                                </div>
                            </dd>
                        </div>
                        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                                <div>
                                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                        Direccion
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            value={data.direction}
                                            onChange={(e) => {handleChange('direction', e.target.value)}}
                                            id="email"
                                            name="email"
                                            type="text"
                                            placeholder=""
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                            />
                                    </div>
                                </div>
                            </dd>
                        </div>
                        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                                <div>
                                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                        Telefono
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            value={data.phone}
                                            onChange={(e) => {handleChange('phone', e.target.value)}}
                                            id="email"
                                            name="email"
                                            type="text"
                                            placeholder=""
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                        />
                                    </div>
                                </div>
                            </dd>
                        </div>
                    </dl>
                </div>
            </div>
    )
}